import {
  differenceInCalendarDays,
  isBefore,
  addDays,
  min,
  subDays,
} from 'date-fns';

export const MAX_DATE_RANGE_DAYS = 366;

export const validateEndDate = (
  value: Date | null,
  startDate: Date | null
): string | boolean => {
  if (startDate && value && isBefore(value, startDate)) {
    return 'End Date must be after Start Date';
  }
  if (
    startDate &&
    value &&
    differenceInCalendarDays(value, startDate) > MAX_DATE_RANGE_DAYS
  ) {
    return `Range cannot exceed 1 year (${MAX_DATE_RANGE_DAYS} days)`;
  }
  return true;
};

export const getEndDateDisabledDays = (
  startDate: Date | null,
  today: Date
): { after: Date; before?: Date } => {
  const yesterday = subDays(today, 1);
  return {
    after: startDate
      ? min([addDays(startDate, MAX_DATE_RANGE_DAYS), yesterday])
      : yesterday,
    ...(startDate && { before: startDate }),
  };
};
